    // 代理
import axios from '../../axios'

export default {
    getAgentList: (data) => axios.get('/products/agent/list', data),// 代理列表
    getPosters: (agentId) => axios.get('/api/api/posters/agent/' + agentId),// 代理海报
    getEquityList: (key, id, data) => axios.get(`/api/api/agent/equity/list/${key}/${id}`, data),// 代理权益列表
    getShareTabs: (agentID,data) => axios.get(`/api/api/agent/equity/list/4/${agentID}/categories`,data),// 分享权益分类列表
    discountInfo: (agentID, data) => axios.get(`/api/api/goods/price/agent/${agentID}`, data),// 代理列表-支付优惠明细
    getEquityTabs: () => axios.get('/api/api/agent/my/equity/tab'),// 查看权益-分类列表
    getMyEquity: (data) => axios.get('/api/api/agent/my/equity', data),// 查看权益-数据
    getGiveEquity: (data) => axios.get('/products/agent/give/num', data),// 查看权益-赠票使用
    // batchUnderway: (data) => axios.get('/api/api/product/batch/underway', data),// 代理获取分批信息 放public了

    getGiveNum: (data) => axios.get('/products/agent/give/detail/num', data),// 代理赠送名额
    getAgentContent: (agentId) => axios.get('/products/agent/details/'+agentId),// 代理详情
    getCouponList: (agentId) => axios.get('/products/agent/details/'+agentId+'/self/coupons'),// 代理详情-优惠券
    getOtherInfo: (agentId) => axios.get('/products/agent/details/'+agentId+'/other'),// 代理详情-其他
    getShareList: (agentId,data) => axios.get('/api/api/agent/v1/'+agentId+'/detail/share',data),// 代理详情-分销产品
    getSelfList: (agentId,data) => axios.get('/products/agent/details/'+agentId+'/self/products',data),// 代理详情-本人学习

    getMyShare: (data) => axios.get('/api/api/agent/v1/0/my/share', data),// 查看权益-可分销产品
    getOtherCoupon: (data) => axios.get('/products/agent/equity/coupons', data),// 查看权益-其它-优惠券
    getSelfStudy: (data) => axios.get('/products/agent/equity/study', data),// 查看权益-自己学
    getservicePerson: () => axios.get('/api/tools/fdd/proxy/person/info?role=proxy'),// 合伙人：个人身份基本信息
    getserviceCompany: () => axios.get('/api/tools/fdd/proxy/company/info?role=proxy'),// 合伙人：企业身份基本信息
    getAgreementSigning:(data) => axios.post('/api/tools/fdd/proxy/pre/sign/protocol',data),// 合伙人：获取待签署的成为合伙人协议信息
    getAgreementprotocol:(data) => axios.post('/api/tools/fdd/proxy/withdrawal/pre/sign/protocol',data),// 合伙人：获取待签署的合伙人对公提现协议信息
    getAgreementactivationl:(data) => axios.post('/passport/agent/activation',data),// 合伙人：代理激活
    
    getUpgradeAgent: (mechanism_id,data) => axios.requestGet('/v1/ucentor/agent-configs/upgrade-agent/'+mechanism_id, data),// 代理升级代理
}